import { render } from "./Chip.vue?vue&type=template&id=4e837ab9&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=4e837ab9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e837ab9"]])

export default __exports__